module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-root"
  }, [_c('router-view'), (_vm.isNewPdpConsentModalVisible) ? _c('PersonalDataConsentModal', {
    on: {
      "close": _vm.closeNewPdpConsentModal,
      "confirm": _vm.approve
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15b24db8","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Root.vue
// module id = 7d1653579465c78fe9c6
// module chunks = 89